'use strict';

(function () {
  angular
    .module('specsguardApp')
    .service('SimpleDialogFormService', SimpleDialogFormService);

  SimpleDialogFormService.$inject = ['$mdDialog', '$document', 'Labels'];

  function SimpleDialogFormService ($mdDialog, $document, Labels) {

    return {
      open: openModal,
      close: closeModal,
      confirm: openConfirm
    };

    // /////////////

    function openConfirm (ev, options, instance) {

      //set some defaults if they are not set
      if (!options.cancel) {
        options.cancel = Labels.getLabel('cancel');
      }
      if (!options.ok) {
        options.ok = Labels.getPlural('delete');
        options.ok_icon = "delete";
      }

      return $mdDialog.show({
        multiple: true,
        controller: 'SimpleDialogFormCtrl',
        controllerAs: '$SimpleDialogFormCtrl',
        templateUrl: 'app-legacy/components/simple-dialog-form/simple-dialog-confirm.tmpl.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        bindToController: true,
        locals: {
          options: options,
          instance: instance
        }
      })
    }

    function closeModal (result) {
      $mdDialog.close(result);
    }

    function openModal (ev, options, instance) {

      let originalInstance = instance || null;

      instance = angular.copy(instance) || {};

      return $mdDialog.show({
        multiple: true,
        controller: 'SimpleDialogFormCtrl',
        controllerAs: '$SimpleDialogFormCtrl',
        templateUrl: 'app-legacy/components/simple-dialog-form/simple-dialog-form.tmpl.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        bindToController: true,
        locals: {
          options: options,
          instance: instance,
          originalInstance: originalInstance
        }
      });
    };
  }
})();
